module.exports = __webpack_public_path__ + "static/media/closeup-button-arrow-line.18f02681.svg";